<template>
  <div id="award-category-edit">
    <v-card>
      <v-app-bar
        color="primary"
        dense
        dark
        elevate-on-scroll
        scroll-target="#scrolling-techniques-7"
      >
        <v-toolbar-title>{{ PageTitle }}</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon dark @click="closePrompt">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card-title></v-card-title>
      <v-card-text>
        <p></p>
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <v-form
          ref="form1"
          v-model="valid1"
          lazy-validation
          v-on:submit.prevent="confirmAlert"
        >
          <v-container class="py-0">
            <v-row wrap>
              <v-col cols="12" sm="6" lg="4" md="6">
                <h6>
                  For Member <br />
                  <br />
                  <span class="text-dark">
                    {{ recordData.MemberId }} - {{ recordData.MemberName }}
                  </span>
                </h6>
              </v-col>
              <v-col>
                <h6><span class="text-danger">* </span> ML Date</h6>
                <v-row align="center">
                  <v-icon color="error" style="width: 15px"
                    >mdi-calendar-clock</v-icon
                  >
                  <v-col cols="6">
                    <v-datetime-picker
                      v-model="MLDate"
                      class="mdi mdi-calendar-range"
                      :time-picker-props="timeProps"
                      time-format="HH:mm:ss"
                      prepend-icon="mdi-calendar-clock"
                    ></v-datetime-picker>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
          <v-row wrap>
            <v-col align="center" cols="12" md="12">
              <v-btn
                :disabled="!valid1"
                @click.prevent="confirmAlert"
                :loading="SubmitFlag"
                elevation="30"
                medium
                color="#1db954"
                class="font-size-h6 px-4 mr-3 white--text"
              >
                Submit
              </v-btn>
              <v-btn
                @click="closePrompt"
                elevation="30"
                medium
                color="#a52a2a"
                class="font-size-h6 px-4 mr-3 white--text"
              >
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>
  
<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    editDateRecordPrompt: {
      required: true,
      type: Boolean,
    },
    recordData: {
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SubmitFlag: false,

      // nullDatetime: null,
      // Date: new Date(),
      // datetimeString: "2019-01-01 12:00",
      // formattedDatetime: "09/01/2019 12:00",
      // textFieldProps: {
      //   appendIcon: "event",
      // },
      // dateProps: {
      //   headerColor: "red",
      // },
      // timeProps: {
      //   useSeconds: true,
      //   ampmInTitle: true,
      // },

      UploadFlag: false,
      ResultFlag: false,

      MLDate: {},
      menu: false,
      modal: false,

      PageInfo: {},
      PageTitle: "Edit ML Date",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      var tr = this.recordData;
      this.MLDate = tr.CreatedAt;
      console.log("tr = ", JSON.stringify(tr));
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideEditDateRecordPrompt", this.ResultFlag);
    },
    getOrganizationTypeOptions() {
      console.log("getOrganizationTypeOptions called");
      var selectbox1_source = "OrganizationType";
      var selectbox1_destination = "OrganizationTypeOptions";
      var selectbox1_url = "api/organization-type/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        // this.toast("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      this.SubmitFlag = true;
      this.ResultFlag = false;

      var tr = this.recordData;

      var upload = {
        UserInterface: 1,
        Year: tr.Year,
        // YearHalf: tr.HalfTxt,
        YearwiseLom: tr.YearWiseLomId,
        Member: tr.MemberId,
        Date: this.MLDate,
      };
      console.log("upload=" + JSON.stringify(upload));

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;

      var add_url = server_url + "api/member-dues/update-ml-date";
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      this.SubmitFlag = true;

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.SubmitFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);
          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.sweetAlert("success", output, true);
            thisIns.ResultFlag = true;
            thisIns.closePrompt();
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SubmitFlag = false;
        });
    },
  },

  beforeMount() {
    this.refreshPageData();
  },
};
</script>
  <style lang="scss">
</style>